import Cookie from "js-cookie";
import store from "../../store";

export default async function redirectCallback({ to, next }) {
  const token = Cookie.get("ecs_user_jwt_token") || null;
  const tokenStore = store.getters["auth/token"];
  const callbackUrl = store.getters["auth/callback"];
  if (to.name === 'Login') {
    store.commit('auth/SET_CALLBACK_URL', to.query.callback_url);
  }
  if (token && tokenStore && callbackUrl && to.name !== "RedirectWarning") {
    next({ name: "RedirectWarning" } );
  }
  if (to.name === "RedirectWarning" && !callbackUrl) {
    next({name: "Dashboard"})
  }
  next();
}
